import { render, staticRenderFns } from "./research-group-list.html?vue&type=template&id=a5bf8c88&scoped=true&external"
import script from "./research-group-list.js?vue&type=script&lang=js&external"
export * from "./research-group-list.js?vue&type=script&lang=js&external"
import style0 from "./research-group-list.scss?vue&type=style&index=0&id=a5bf8c88&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5bf8c88",
  null
  
)

export default component.exports